import {formattedPrice} from "../helpers/MainHelper";

export const sparkleCardData = (data)=> [
  {
    heading: "Tamamlanan Servis Cirosu",
    money: `${formattedPrice(data.totalRevenue.total.toFixed(2))}`,
    perText: `${data.totalRevenue.percentChange.toFixed(2)}% Geçen haftaya göre`,
    sparklineData: {
      type: "line",
      data: data.totalRevenue.dailyTotal,
      areaStyle: {
        color: "#fac091",
      },
      itemStyle: {
        color: "#f79647",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "Servisler",
    money: `${data.operationTotal.total}`,
    perText: `${data.operationTotal.percentChange.toFixed(2)}% Geçen haftaya göre`,
    sparklineData: {
      type: "line",
      data: data.operationTotal.dailyTotal,
      areaStyle: {
        color: "#a092b0",
      },
      itemStyle: {
        color: "#604a7b",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "Teklifler",
    money: `${formattedPrice(data.offerTotal.total)}`,
    perText: `${data.offerTotal.percentChange.toFixed(2)}% Geçen haftaya göre`,
    sparklineData: {
      type: "line",
      data: data.offerTotal.dailyTotal,
      areaStyle: {
        color: "#92cddc",
      },
      itemStyle: {
        color: "#4aacc5",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "Müşteriler",
    money: `${data.customerTotal.total}`,
    perText: `${data.customerTotal.percentChange.toFixed(2)}% Geçen haftaya göre`,
    sparklineData: {
      type: "line",
      data: data.customerTotal.dailyTotal,
      areaStyle: {
        color: "#95b3d7",
      },
      itemStyle: {
        color: "#4f81bc",
      },
      symbolSize: 1,
    },
  },
];

export const sparkleCardData1 = [
  {
    heading: "EARNINGS",
    money: "$22,500",
    perText: "19% Geçen haftaya göre",
    sparklineData: {
      type: "line",
      data: [1, 0, 5, 6, 3, 7],
      areaStyle: {
        color: "#f79647",
      },
      itemStyle: {
        color: "#f79647",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "SALES",
    money: "$500",
    perText: "19% Geçen haftaya göre",
    sparklineData: {
      type: "line",
      data: [6, 1, 5, 4, 2, 8],
      areaStyle: {
        color: "#604a7b",
      },
      itemStyle: {
        color: "#604a7b",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "VISITS",
    money: "$21,215",
    perText: "19% Geçen haftaya göre",
    sparklineData: {
      type: "line",
      data: [2, 8, 5, 6, 2, 9],
      areaStyle: {
        color: "#4aacc5",
      },
      itemStyle: {
        color: "#4aacc5",
      },
      symbolSize: 1,
    },
  },
  {
    heading: "LIKES",
    money: "$421,215",
    perText: "19% Geçen haftaya göre",
    sparklineData: {
      type: "line",
      data: [2, 6, 1, 9, 1, 8],
      areaStyle: {
        color: "#4f81bc",
      },
      itemStyle: {
        color: "#4f81bc",
      },
      symbolSize: 1,
    },
  },
];

export const topTypesOption = (data) => {
  const uniqueMonths = Array.from(new Set(data.map(item => item.month_year)));

  const legendData = Array.from(new Set(data.map((item) => item.type_name)));
  const chartColors = ["#2f6fed", "#17a878", "#7758d7", "#ed8f35", "#e5667c", "#3ca2bd"];

  const series = legendData.map((name, index) => ({
    name: name,
    type: "bar",
    stack: "Gadgets",
    data: uniqueMonths.map(month_year => {
      const foundItem = data.find(item => item.type_name === name && item.month_year === month_year);
      return foundItem ? foundItem.operation_price : 0;
    }),
    itemStyle: {
      color: chartColors[index % chartColors.length],
      borderRadius: [4, 4, 0, 0],
    },
    barMaxWidth: 28,
  }));

  const months = uniqueMonths.map(month_year => {
    const [year, month] = month_year.split('-');
    const monthName = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'][parseInt(month) - 1];
    return `${monthName} ${year}`;
  });
  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: legendData,
      right: "4%",
      top: 3,
      textStyle: {
        color: "#718096",
        fontSize: 10,
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      top: 48,
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: months,
        axisLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: "#8190a5",
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#e9eef5",
          },
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          formatter: function (value, index) {
            if (value > 0) {
              return value / 1000 + " K";
            } else {
              return 0;
            }
          },
          textStyle: {
            color: "#8190a5",
          },
        },
      },
    ],
    series: series,
  };
};
export const topBranchesOption = (data) => {
  const uniqueMonths = Array.from(new Set(data.map(item => item.month_year)));

  const legendData = Array.from(new Set(data.map((item) => item.branch_name)));
  const chartColors = ["#17a878", "#2f6fed", "#7758d7", "#ed8f35", "#e5667c", "#3ca2bd"];

  const series = legendData.map((name, index) => ({
    name: name,
    type: "bar",
    stack: "Gadgets",
    data: uniqueMonths.map(month_year => {
      const foundItem = data.find(item => item.branch_name === name && item.month_year === month_year);
      return foundItem ? foundItem.operation_price : 0;
    }),
    itemStyle: {
      color: chartColors[index % chartColors.length],
      borderRadius: [4, 4, 0, 0],
    },
    barMaxWidth: 28,
  }));

  const months = uniqueMonths.map(month_year => {
    const [year, month] = month_year.split('-');
    const monthName = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'][parseInt(month) - 1];
    return `${monthName} ${year}`;
  });
  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: legendData,
      right: "4%",
      top: 3,
      textStyle: {
        color: "#718096",
        fontSize: 10,
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      top: 48,
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: months,
        axisLine: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: "#8190a5",
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#e9eef5",
          },
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          formatter: function (value, index) {
            if (value > 0) {
              return value / 1000 + " K";
            } else {
              return 0;
            }
          },
          textStyle: {
            color: "#8190a5",
          },
        },
      },
    ],
    series: series,
  };
};

export const topRevenueOption = {
  tooltip: {
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    top: 0,
    right: 0,
    left: 0,
    bottom: "3%",
  },
  xAxis: [
    {
      type: "category",

      axisLine: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: "#C2C2C2",
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      name: "Mobile",
      type: "bar",
      stack: "Gedgets",
      data: [2, 5, 4, 8, 3, 9, 1, 5],
      itemStyle: {
        color: "#6ebdd1",
      },
      barWidth: "6px",
    },
  ],
};
export const topRevenueMonthlyOption = {
  tooltip: {
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  xAxis: [
    {
      type: "category",
      axisLine: {
        show: false,
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      minInterval: 10,
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      type: "bar",
      data: [
        3, 1, 5, 4, 7, 8, 2, 3, 1, 4, 6, 5, 4, 4, 2, 3, 1, 5, 4, 7, 8, 2, 3, 1,
        4, 6, 5, 4, 4, 2,
      ],
      itemStyle: {
        color: "#6ebdd1",
      },
      barWidth: "2px",
    },
  ],
};

export const visitsSparcalOption = {
  tooltip: {
    trigger: "axis",
    formatter: function (value) {
      return value[0].axisValue;
    },
  },
  grid: {
    top: "20%",
    bottom: 0,
    right: "5%",
    left: "5%",
  },
  xAxis: [
    {
      show: false,
      type: "category",
      boundaryGap: false,
      axisLine: {
        show: false,
      },
      data: [4, 6, 3, 2, 5, 6, 5, 4],
    },
  ],
  yAxis: [
    {
      show: false,
      type: "value",
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      type: "line",
      data: [4, 6, 3, 2, 5, 6, 5, 4],
      itemStyle: {
        color: "#f4516c",
      },
      lineStyle: {
        width: 0.8,
      },
      symbolSize: 1,
    },
  ],
};

export const visitorsSparcalOption = {
  tooltip: {
    trigger: "axis",
    formatter: function (value) {
      return value[0].axisValue;
    },
  },
  grid: {
    top: "20%",
    bottom: 0,
    right: "5%",
    left: "5%",
  },
  xAxis: [
    {
      show: false,
      type: "category",
      boundaryGap: false,
      axisLine: {
        show: false,
      },
      data: [3, 5, 1, 6, 5, 4, 8, 3],
    },
  ],
  yAxis: [
    {
      show: false,
      type: "value",
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      type: "line",
      data: [3, 5, 1, 6, 5, 4, 8, 3],
      itemStyle: {
        color: "#00c5dc",
      },
      lineStyle: {
        width: 0.8,
      },
      symbolSize: 1,
    },
  ],
};

export const saleGaugeOption = {
  title: {
    text: "63",
    x: "center",
    y: "center",
    textStyle: {
      color: "rgb(33, 33, 33)",
      fontFamily: "Arial",
      fontSize: 20,
      fontWeight: "bolder",
    },
  },
  grid: {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  tooltip: {
    show: true,
    formatter: function (params, ticket, callback) {
      return '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#212121;"></span>63';
    },
  },
  series: [
    {
      type: "pie",
      startAngle: 215,
      clockWise: 1,
      radius: [38, 50],
      itemStyle: {
        normal: {
          label: { show: false },
          labelLine: { show: false },
        },
      },
      data: [
        {
          value: 45,
          itemStyle: {
            color: "#212121",
            emphasis: {
              color: "#212121",
            },
          },
        },
        {
          value: 34,
          itemStyle: {
            normal: {
              color: "#EEEEEE",
              label: { show: false },
              labelLine: { show: false },
              tooltip: { show: false },
            },
            emphasis: {
              color: "#EEEEEE",
            },
          },
        },
        {
          value: 33,
          itemStyle: {
            normal: {
              color: "rgba(0,0,0,0)",
              label: { show: false },
              labelLine: { show: false },
              tooltip: { show: false },
            },
          },
        },
      ],
    },
  ],
};

export const dataManagetOption = {
  tooltip: {
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    top: -5,
    bottom: 0,
    right: 0,
    left: 0,
  },
  xAxis: [
    {
      type: "category",
      axisLine: {
        show: false,
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      type: "bar",
      stack: "Gedgets",
      data: [2, 0, 5, 6, 4, 8, 7, 0, 6, 2, 3, 5, 6, 2, 0, 4, 0],
      itemStyle: {
        color: "#6ebdd1",
      },
      barWidth: "3px",
    },
    {
      type: "bar",
      stack: "Gedgets",
      data: [0, -1, 0, 0, 0, 0, 0, -5, 0, 0, 0, 0, 0, 0, -3, 0, -2],
      itemStyle: {
        color: "#db2a0b",
      },
      barWidth: "3px",
    },
  ],
};

export const sparkcleCardSparcalOption = {
  tooltip: {
    axisPointer: {
      type: "shadow",
    },
  },

  grid: {
    top: 1,
    bottom: 0,
    right: 0,
    left: 0,
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      axisLine: {
        show: false,
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      splitLine: { show: false },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  series: [
    {
      type: "line",
      data: [1, 3, 5, 1, 4, 2],
      areaStyle: {
        color: "#00c5dc",
      },
      itemStyle: {
        color: "#00c5dc",
      },
      symbolSize: 1,
    },
  ],
};
